import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Check, Package, ArrowRight } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

export default function CheckoutSuccessPage() {
  const [searchParams] = useSearchParams();
  const { t } = useLang();
  const orderId = searchParams.get('order_id');

  return (
    <div className="min-h-screen pt-24 pb-16 px-6 md:px-12 lg:px-24 flex items-center justify-center">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center bg-[#4A5D23] text-white rounded-full">
          <Check className="w-10 h-10" />
        </div>
        
        <h1 className="text-3xl md:text-4xl font-light tracking-tight mb-4">
          {t({ it: 'Ordine Confermato!', en: 'Order Confirmed!' })}
        </h1>
        
        <p className="text-[#57534E] mb-6">
          {t({
            it: 'Grazie per il tuo ordine. Riceverai una email di conferma a breve.',
            en: 'Thank you for your order. You will receive a confirmation email shortly.',
          })}
        </p>

        {orderId && (
          <div className="bg-[#F2EFE9] p-6 mb-8">
            <p className="text-sm text-[#57534E] mb-1">{t({ it: 'Numero Ordine', en: 'Order Number' })}</p>
            <p className="font-mono font-medium text-lg">{orderId}</p>
          </div>
        )}

        <div className="space-y-4">
          <Link
            to="/account/orders"
            data-testid="view-orders-btn"
            className="w-full btn-primary flex items-center justify-center gap-2"
          >
            <Package className="w-5 h-5" />
            {t({ it: 'Visualizza i tuoi Ordini', en: 'View Your Orders' })}
          </Link>
          
          <Link
            to="/shop"
            data-testid="continue-shopping-btn"
            className="w-full py-3 border border-[#E5E0D8] hover:border-[#1C1917] flex items-center justify-center gap-2 transition-colors"
          >
            {t({ it: 'Continua lo Shopping', en: 'Continue Shopping' })}
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </div>
  );
}
